import { RESET_UPDATE_CONTACT_ADDRESS_ERROR } from 'redux/modules/address/actions/types';

export const resetUpdateContactAddressError = () => ({
  type: RESET_UPDATE_CONTACT_ADDRESS_ERROR,
});
